<template>
  <div class="adgroup-commissions campaign-step">
    <div class="step-header">
      <div class="step-icon"><img src="/images/percent.svg" alt="commissions" /></div>
      <h2>{{ $t('messages.commissions') || 'Commissions' }}</h2>
    </div>
    <div class="settings-content">
      <p>{{ $t('messages.configure_commissions_for_adgroup') || 'Commissions placeholder.' }}</p>
    </div>
  </div>
</template>

<script>
export default { name: 'AdGroupCommissions' };
</script>

<style scoped>
.adgroup-commissions { padding: 8px 0; }
</style>

